export default {
  SET_BASKET_FILE_IMPORT(state, { entity }) {
    state.basketFileImport = entity
  },
}
